/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From 45 to 27: ((45 − 27) ÷ 45) × 100 = 40% decrease.`)
};

const es_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 45 a 27: ((45 − 27) ÷ 45) × 100 = 40% de disminución.`)
};

const de_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von 45 auf 27: ((45 − 27) ÷ 45) × 100 = 40% Rückgang.`)
};

const nl_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van 45 naar 27: ((45 − 27) ÷ 45) × 100 = 40% daling.`)
};

const fr_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 45 à 27 : ((45 − 27) ÷ 45) × 100 = diminution de 40 %.`)
};

const it_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 45 a 27: ((45 − 27) ÷ 45) × 100 = calo del 40%.`)
};

const pt_br2_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 45 para 27: ((45 − 27) ÷ 45) × 100 = 40% de diminuição.`)
};

const pt_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De 45 para 27: ((45 − 27) ÷ 45) × 100 = 40% de diminuição.`)
};

const ja_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45から27へ: ((45 − 27) ÷ 45) × 100 = 40%減少。`)
};

const zh_pct_decrease_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 45 到 27：((45 − 27) ÷ 45) × 100 = 减少 40%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_ex3", locale)
	if (locale === "en") return en_pct_decrease_ex3(inputs)
	if (locale === "es") return es_pct_decrease_ex3(inputs)
	if (locale === "de") return de_pct_decrease_ex3(inputs)
	if (locale === "nl") return nl_pct_decrease_ex3(inputs)
	if (locale === "fr") return fr_pct_decrease_ex3(inputs)
	if (locale === "it") return it_pct_decrease_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_ex3(inputs)
	if (locale === "pt") return pt_pct_decrease_ex3(inputs)
	if (locale === "ja") return ja_pct_decrease_ex3(inputs)
	return zh_pct_decrease_ex3(inputs)
};